export const getNotificationTypes = state => state.notificationTypes;
export const getFcmDevices = state => state.fcmDevices;
